<template>
  <div v-if="value">
    <span class="error--text">{{ displayTime }}</span>
  </div>
</template>

<script>
export default {
  name: "SecondToHumanTime",
  props: {
    value: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    displayTime: null,
  }),
  mounted() {
    this.calHumanTime();
  },
  beforeDestroy() {},
  methods: {
    calHumanTime() {
      if (!this.value) {
        return false;
      }

      const totalSeconds = this.value;

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (hours > 0) {
        this.displayTime = `${hours} giờ ${minutes} phút`;
      } else if (minutes > 0) {
        this.displayTime = `${minutes} phút ${seconds} giây`;
      } else if (seconds > 0) {
        this.displayTime = `${seconds} giây`;
      } else {
        this.displayTime = `${hours} giờ ${minutes} phút ${seconds} giây`;
      }
    },
  },
};
</script>

<style scoped></style>
